var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    id: "invoice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    x: 8,
    y: 27,
    fill: "#bfbfbf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M44,11H38V4a3,3,0,0,1,6,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M40.33.07C40.06,0,42.37,0,7,0A4,4,0,0,0,3,4V47a1,1,0,0,0,1,1H38a1,1,0,0,0,1-1V12h5a1,1,0,0,0,1-1V4A4,4,0,0,0,40.33.07ZM37,4V46H5V4A2,2,0,0,1,7,2H37.56A3.91,3.91,0,0,0,37,4Zm6,6H39V4a2,2,0,0,1,4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6459",
    d: "M8 14a1 1 0 0 0 1-1V7A1 1 0 0 0 7 7v6A1 1 0 0 0 8 14zM12 14a1 1 0 0 0 1-1V10.3l2.17 3.25A1 1 0 0 0 17 13V7a1 1 0 0 0-2 0V9.7L12.83 6.45A1 1 0 0 0 11 7v6A1 1 0 0 0 12 14zM21.05 13.32a1 1 0 0 0 1.9 0l2-6a1 1 0 0 0-1.9-.64L22 9.84 21 6.68a1 1 0 0 0-1.9.64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M8 19H18a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2zM8 23h6a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M34 17H28a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zM34 26H8a1 1 0 0 0-1 1V43a1 1 0 0 0 1 1H34a1 1 0 0 0 1-1V27A1 1 0 0 0 34 26zm-1 4H24V28h9zM13 30V28h9v2zm9 2V42H13V32zM11 28v2H9V28zM9 32h2V42H9zM24 42V32h9V42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIco);
export default __webpack_public_path__ + "static/media/invoiceIco.493f25cee6a86b817800b9069979e7f4.svg";
export { ForwardRef as ReactComponent };